import React from "react";
import Icon from "@Components/Icons/Tooltip";
import Warning from "@Components/Icons/Warning";
import styles from "./index.module.scss";
import RenderTooltip from "./RenderTooltip";
export default class HoverTooltip extends React.Component {
    tooltipRef;
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
        this.tooltipRef = React.createRef();
    }
    handleHover = () => {
        this.setState({ visible: true });
    };
    handleOut = () => {
        this.setState({ visible: false });
    };
    render() {
        return (React.createElement("span", { className: `${styles.wrapper} ${this.props.iconClassName}`, ref: this.tooltipRef },
            this.props.icon ? (React.createElement("div", { onMouseOver: this.handleHover, onMouseOut: this.handleOut, onFocus: this.handleHover, onBlur: this.handleOut }, this.props.icon)) : (React.createElement(React.Fragment, null,
                this.props.warning !== true && (React.createElement(Icon, { onMouseOver: this.handleHover, onMouseOut: this.handleOut, size: "12", light: this.props.light })),
                this.props.warning === true && (React.createElement(Warning, { onMouseOver: this.handleHover, onMouseOut: this.handleOut, size: "1.2rem" })))),
            this.state.visible && (React.createElement(RenderTooltip, { reference: this.tooltipRef, style: this.props.style, className: this.props.className }, this.props.children))));
    }
}
